import type { AttributeChoiceType, AttributeType, DishAttrType } from '../../../types/product';
import { useEffect, useState } from 'react';

import { Checkbox } from '../../../shared/Checkbox';

interface Props extends AttributeType {
  type: AttributeChoiceType;
  max: number | 0;
  currencySymbol: string;
  attribute: string;
  dishAttributes: DishAttrType;
  setDishAttributes: (attr: DishAttrType) => void;
  modifier?: 'true' | 'false';
  setHardReset: (value: boolean) => void;
}


export const Attribute = (props: Props) => {
  const [selected, setSelected] = useState(false);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (Object.keys(props.dishAttributes).length === 0) {
      setSelected(false);
    }
  }, [props.dishAttributes]);

  const getAttributeLabel = (name: string = props.name) => {
    if (props.price && props.price > 0) {
      return `${name} (${props.currencySymbol}${props.price})`;
    }
    return name;
  };

  const onChange = (name: string = props.name) => {
    if (!selected) {
      const altAttributes = props.dishAttributes[props.attribute] || [];
      if (altAttributes.length >= props.max || (altAttributes.length && props.type === 'single')) {
        setDisabled(true);
        return;
      }
      setSelected(true);
      altAttributes.push({ name, price: props.price, description: props.description });

      props.setDishAttributes({
        ...props.dishAttributes,
        [props.attribute]: altAttributes,
      });
    } else {
      const altAttributes = props.dishAttributes[props.attribute].filter((elem) => elem.name !== name);
      if (disabled) {
        setDisabled(false);
      }
      setSelected(false);

      if (props.modifier === 'true') {
        props.setHardReset(true);
        props.setDishAttributes({
          [props.attribute]: altAttributes,
        });
        setInterval(() => {
          props.setHardReset(false);
        }, 100);
        return;
      }

      props.setDishAttributes({
        ...props.dishAttributes,
        [props.attribute]: altAttributes,
      });
    }
  };

  const attributeMap = (name: string = props.name) => {
    switch (props.type) {
      case 'single':
        return (
          <Checkbox
            name={`${name}-${props.attribute}`}
            id={name}
            label={getAttributeLabel(name)}
            onChange={() => onChange(name)}
            checked={selected}
          />
        );
      case 'multiple':
        return (
          <Checkbox
            name={`${name}-${props.attribute}`}
            id={name}
            label={getAttributeLabel(name)}
            onChange={() => onChange(name)}
            checked={selected}
          />
        );
      default:
        return null;
    }
  };

  if (props.name[0] === '$') {
    const splittedValue = props.name.split('$');
    if (props.dishAttributes.hasOwnProperty(splittedValue[1])) {
      if (props.dishAttributes[splittedValue[1]][0]?.name === splittedValue[2]) {
        return attributeMap(splittedValue[3]);
      }
    }
    return null;
  }

  return (
    <div>{attributeMap()}</div>
  );

};
